import Vue from "vue";
import Router from "vue-router";
// 使用路由
Vue.use(Router);
// 导出路由模块
export default new Router({
    routes: [{
            path: "/",
            redirect: "/login"
        },
        {
            path: "/index",
            component: () =>
                import ("@/pages/index/index.vue"),
            name: "index",
            redirect: "/msgl",
            children: [{
                    path: "/home",
                    component: () =>
                        import ("@/pages/home/index.vue"),
                    name: "home"
                },
                {
                    path: '/index',
                    component: () =>
                        import ('@/pages/index/index.vue'),
                    name: 'index',
                    redirect: '/msgl',
                    children: [{
                            path: '/home',
                            component: () =>
                                import ('@/pages/home/index.vue'),
                            name: 'home',
                        },
                        {
                            path: '/homeItem',
                            component: () =>
                                import ('@/pages/homeItem/index.vue'),
                            name: 'homeItem',
                        },
                        {
                            path: '/companyAuth',
                            component: () =>
                                import ('@/pages/companyAuth/companyAuth.vue'),
                            name: 'companyAuth',
                        },
                        {
                            path: '/confirmPublishJob',
                            component: () =>
                                import ('@/pages/confirmPublishJob/confirmPublishJob.vue'),
                            name: 'confirmPublishJob',
                        },
                        {
                            path: '/publishSuccess',
                            component: () =>
                                import ('@/pages/publishSuccess/publishSuccess.vue'),
                            name: 'publishSuccess',
                        }, {
                            path: '/signIn',
                            component: () =>
                                import ('@/pages/signIn/signIn.vue'),
                            name: 'signIn',
                        }, {
                            path: '/payOrder',
                            component: () =>
                                import ('@/pages/home/payOrder.vue'),
                            name: 'payOrder',
                        }, {
                            path: '/payOrder2',
                            component: () =>
                                import ('@/pages/home/payOrder2.vue'),
                            name: 'payOrder2',
                        }
                    ]
                }, {
                    path: "/findAbility",
                    component: () =>
                        import ("@/pages/home/findAbility.vue"),
                    // meta: {keepAlive:true},
                    name: "findAbility"
                },
                {
                    path: "/createCard",
                    component: () =>
                        import ("@/pages/ai-companyInfo/index.vue"),
                    meta: { keepAlive: true },
                    name: "createCard"
                }, {
                    path: "/findAbility2",
                    component: () =>
                        import ("@/pages/home/findAbility2.vue"),
                    name: "findAbility2"
                }, {
                    path: "/abilityInfo",
                    component: () =>
                        import ("@/pages/home/abilityInfo.vue"),
                    name: "abilityInfo"
                },
                {
                    path: "/homeItem",
                    component: () =>
                        import ("@/pages/homeItem/index.vue"),
                    name: "homeItem"
                },
                {
                    path: "/companyAuth",
                    component: () =>
                        import ("@/pages/companyAuth/companyAuth.vue"),
                    name: "companyAuth"
                },
                {
                    path: "/confirmPublishJob",
                    component: () =>
                        import ("@/pages/confirmPublishJob/confirmPublishJob.vue"),
                    name: "confirmPublishJob"
                },
                {
                    path: "/publishSuccess",
                    component: () =>
                        import ("@/pages/publishSuccess/publishSuccess.vue"),
                    name: "publishSuccess"
                },
                {
                    path: "/signIn",
                    component: () =>
                        import ("@/pages/signIn/signIn.vue"),
                    name: "signIn"
                }, {
                    path: "/message",
                    component: () =>
                        import ("@/pages/message/index.vue"),
                    name: "message"
                }, {
                    path: "/jsInfo",
                    component: () =>
                        import ("@/pages/jsInfo/jsInfo.vue"),
                    name: "jsInfo"
                },
                {
                    path: "account-mgt",
                    component: () =>
                        import ("@/pages/account-mgt/index.vue"),
                    name: "accountMgt",
                    redirect: "/index/account-mgt/assetaccount",
                    children: [{
                            path: "workingtime",
                            component: () =>
                                import ("@/pages/account-mgt/pages/workingtime/index.vue"),
                            name: "workingtime"
                        }, {
                            path: "workingInfo",
                            component: () =>
                                import ("@/pages/account-mgt/pages/workingtime/info.vue"),
                            name: "workingInfo"
                        },
                        {
                            path: "workingtime-edit",
                            component: () =>
                                import ("@/pages/account-mgt/pages/workingtime/edit.vue"),
                            name: "workingtimeEdit"
                        },

                        {
                            path: "assetaccount",
                            component: () =>
                                import ("@/pages/account-mgt/pages/assetaccount/index.vue"),
                            name: "assetaccount"
                        },
                        {
                            path: "assetaccount-invoice",
                            component: () =>
                                import ("@/pages/account-mgt/pages/assetaccount/invoice.vue"),
                            name: "AssetaccountInvoice"
                        },
                        {
                            path: "assetaccount-recharge",
                            component: () =>
                                import ("@/pages/account-mgt/pages/assetaccount/recharge.vue"),
                            name: "AssetaccountRecharge"
                        },
                        {
                            path: "assetaccount-recharge-pay",
                            component: () =>
                                import ("@/pages/account-mgt/pages/assetaccount/alipay.vue"),
                            name: "AssetaccountRechargePay"
                        },
                        {
                            path: "ordermgt",
                            component: () =>
                                import ("@/pages/account-mgt/pages/ordermgt/index.vue"),
                            name: "ordermgt"
                        },
                        {
                            path: "ordermgt-detail",
                            component: () =>
                                import ("@/pages/account-mgt/pages/ordermgt/detail.vue"),
                            name: "ordermgtDetail"
                        },

                        {
                            path: "mystaff",
                            component: () =>
                                import ("@/pages/account-mgt/pages/mystaff/index.vue"),
                            name: "mystaff"
                        },
                        {
                            path: "fpgl",
                            component: () =>
                                import ("@/pages/account-mgt/pages/fpgl/index.vue"),
                            name: "fpgl"
                        },
                        {
                            path: "fpgl-fpDetail",
                            component: () =>
                                import ("@/pages/account-mgt/pages/fpgl/fpDetail.vue"),
                            name: "fpgl-fpDetail"
                        },
                        {
                            path: "fpgl-fpOrderDetail",
                            component: () =>
                                import ("@/pages/account-mgt/pages/fpgl/orderDetail.vue"),
                            name: "fpgl-fpOrderDetail"
                        },
                        {
                            path: "toDoCenter",
                            component: () =>
                                import ("@/pages/account-mgt/pages/toDoCenter/index.vue"),
                            name: "toDoCenter"
                        },
                        {
                            path: "jsdgl",
                            component: () =>
                                import ("@/pages/account-mgt/pages/jsdgl/index.vue"),
                            name: "jsdgl"
                        },
                        {
                            path: "assetaccount-repayment",
                            component: () =>
                                import ("@/pages/account-mgt/pages/assetaccount/repayment.vue"),
                            name: "assetaccountRepayment"
                        }
                    ]
                },
                {
                    path: "user-setting",
                    component: () =>
                        import ("@/pages/user-setting/index.vue"),
                    name: "userSetting",
                    redirect: "/index/user-setting/contact",
                    children: [{
                            path: "info",
                            component: () =>
                                import ("@/pages/user-setting/pages/info/index.vue"),
                            name: "userSettingInfo"
                        },
                        {
                            path: "contact",
                            component: () =>
                                import ("@/pages/user-setting/pages/contact/index.vue"),
                            name: "userSettingContact"
                        },
                        {
                            path: "security",
                            component: () =>
                                import ("@/pages/user-setting/pages/security/index.vue"),
                            name: "userSettingSecurity"
                        }
                    ]
                }, {
                    path: "/jobHistory",
                    component: () =>
                        import ("@/pages/jobHistory/index.vue"),
                    name: "jobHistory"
                }, {
                    path: "/jobDetails",
                    component: () =>
                        import ("@/pages/jobHistory/jobDetails.vue"),
                    name: "jobDetails"
                }, {
                    path: "/chat",
                    component: () =>
                        import ("@/pages/chat/index.vue"),
                    name: "chat"
                }, {
                    path: "/interest",
                    component: () =>
                        import ("@/pages/interest/index.vue"),
                    name: "interest"
                }, {
                    path: "/income",
                    component: () =>
                        import ("@/pages/income/income.vue"),
                    name: "income",
                    meta: {
                        keepAlive: false // 不需要被缓存
                    }
                }, {
                    path: "/cashOut",
                    component: () =>
                        import ("@/pages/income/cashOut.vue"),
                    name: "cashOut",
                    meta: {
                        keepAlive: false // 不需要被缓存
                    }
                }, {
                    path: '/paySuccess',
                    component: () =>
                        import ('@/pages/home/paySuccess.vue'),
                    name: 'paySuccess',
                }, {
                    path: '/aliPay',
                    component: () =>
                        import ('@/pages/home/aliPay.vue'),
                    name: 'aliPay',
                }, {
                    path: "/aistart",
                    component: () =>
                        import ("@/pages/ai-start/index.vue"),
                    name: "aistart"
                }
            ]
        },
        {
            path: "/login",
            component: () =>
                import ("@/pages/login/index.vue"),
            name: "login"
        },

        {
            path: "/staticInfo1",
            component: () =>
                import ("@/pages/staticInfo/staticInfo1.vue"),
            name: "staticInfo1"
        },
        {
            path: "/staticInfo2",
            component: () =>
                import ("@/pages/staticInfo/staticInfo2.vue"),
            name: "staticInfo2"
        },
        {
            path: "/staticInfo3",
            component: () =>
                import ("@/pages/staticInfo/staticInfo3.vue"),
            name: "staticInfo3"
        },
        {
            path: "/staticInfo4",
            component: () =>
                import ("@/pages/staticInfo/staticInfo4.vue"),
            name: "staticInfo4"
        },
        {
            path: "/staticInfo5",
            component: () =>
                import ("@/pages/staticInfo/staticInfo5.vue"),
            name: "staticInfo5"
        },
        {
            path: "/staticInfo6",
            component: () =>
                import ("@/pages/staticInfo/staticInfo6.vue"),
            name: "staticInfo6"
        },
        {
            path: "/staticInfo7",
            component: () =>
                import ("@/pages/staticInfo/staticInfo7.vue"),
            name: "staticInfo7"
        },
        {
            path: "/staticInfo8",
            component: () =>
                import ("@/pages/staticInfo/staticInfo8.vue"),
            name: "staticInfo8"
        },
        {
            path: "/staticInfo9",
            component: () =>
                import ("@/pages/staticInfo/staticInfo9.vue"),
            name: "staticInfo9"
        }, {
            path: "/staticInfoCard",
            component: () =>
                import ("@/pages/staticInfo/staticInfoCard.vue"),
            name: "staticInfoCard"
        }, {
            path: "/staticInfoCard2",
            component: () =>
                import ("@/pages/staticInfo/staticInfoCard2.vue"),
            name: "staticInfoCard2"
        }, {
            path: "/staticInfoCard3",
            component: () =>
                import ("@/pages/staticInfo/staticInfoCard3.vue"),
            name: "staticInfoCard3"
        }, {
            path: "/staticInfoCard4",
            component: () =>
                import ("@/pages/staticInfo/staticInfoCard4.vue"),
            name: "staticInfoCard4"
        }, {
            path: "/staticInfoCard5",
            component: () =>
                import ("@/pages/staticInfo/staticInfoCard5.vue"),
            name: "staticInfoCard5"
        }, {
            path: "/staticInfoCard6",
            component: () =>
                import ("@/pages/staticInfo/staticInfoCard6.vue"),
            name: "staticInfoCard6"
        }, {
            path: "/staticInfoResult",
            component: () =>
                import ("@/pages/staticInfo/staticInfoResult.vue"),
            name: "staticInfoResult"
        },
        //  {
        //     path: "/createCard",
        //     component: () =>
        //         import ("@/pages/staticInfo/createCard.vue"),
        //     name: "createCard"
        // },
        {
            path: "/welcome",
            component: () =>
                import ("@/pages/welcome/welcome.vue"),
            name: "welcome"
        },
        {
            path: "/aifinish",
            component: () =>
                import ("@/pages/ai-finish/index.vue"),
            name: "aifinish"
        },
        {
            path: "/payment",
            component: () =>
                import ("@/pages/payment/index.vue"),
            name: "payment"
        }, {
            path: "/businessLicense",
            component: () =>
                import ("@/pages/staticInfo/businessLicense.vue"),
            name: "businessLicense"
        },

        {
            path: "/aiing",
            component: () =>
                import ("@/pages/ai-ing/index.vue"),
            name: "aiing"
        }
    ]
});


// WEBPACK FOOTER //
// ./src/router/index.js